<template>
  <div>
    <v-header :inputName='Name'></v-header>
    <v-massage></v-massage>
    <vMassage1 v-if="selectmajorlist.length!=0" :selectlist="selectmajorlist" :flag="false"></vMassage1>
    <tianbaotype ref="tianbaotype" v-if="tianbaoType!=0" @changeType="changeType" :allData="allData" :guding="guding">
    </tianbaotype>
    <vCrumbs @search="searchMajor"></vCrumbs>

    <div class="container centea" style="width: 1280px;">
      <div class="query" :class="{'gudingop':guding}" :style="{top:tianbaoType==0?'70px':'110px'}">
        <div class="queryAll">符合条件志愿:<span style="margin-left: 10px;margin-right: 10px;">{{total}}</span>(个)
        </div>
        <div>
          <el-checkbox style="padding: 4px 11px;height: 30px;" true-label="1" @change="searchName" border size="medium" false-label=""
            v-model="queryObj.collegeNature">只显公立</el-checkbox>
        </div>
        <div class="query_top">
          <p>院校：</p>
          <input type="text" v-model="queryObj.collegeName" placeholder="查询院校名称" @keydown.enter="searchName">
        </div>
        <div class="query_top">
          <p>专业：</p>
          <input type="text" v-model="queryObj.majorName" placeholder="查询专业名称" @keydown.enter="searchName">
        </div>
        <!-- <div class="query_top"  v-if="type == 'cyc'">
          <p>冲一冲上限：</p>
          <input type="text" v-model="queryObj.up" placeholder="冲一冲上限" @keydown.enter="getAllData">
        </div> -->
        <!-- <div class="query_top" v-if="type == 'dyd'">
          <p>专业：</p>
          <input type="text" v-model="queryObj.down" placeholder="垫一垫下限" @keydown.enter="searchName">
        </div> -->
        <div class="query_bot" @click="searchName">
          <img src="../../../src/assets/img/tbfdj.png" alt="">
          <p>查询志愿</p>
        </div>
        <div style="width: 235px;justify-content: center;display: flex;">
          <!-- <el-slider
          style="width: 160px;"
                v-model="queryObj.fenshu"
                range

                :min="750" :max="180">
              </el-slider> -->
        </div>
        <div class="query_bot" style="color: #F53824;width: 160px;background: #FFFFFF;border:1px solid #F53824; " v-if="tianbaoType!=0">
          <p @click="rateshow = !rateshow" style="color: #F53824;">概率显示&nbsp;&nbsp;:&nbsp;&nbsp;
          <div @click="rateshow = !rateshow"  style="color: #F53824;font-weight: 800;font-size: 18px;">{{rateSelect==''?'全部':rateSelect+"%"}}</div>
          </p>
        </div>
        <div class="ratelist" v-if="rateshow">
          <div class="ratecontent">
             <div style="width: 100%;text-align: center;font-size: 14px;font-weight: 400;">概&nbsp;&nbsp;率&nbsp;&nbsp;选&nbsp;&nbsp;择</div>
            <div class="rateitem" :class="{rateitem_active:rateSelect == ''}" @click="selectrate('')">全部</div>
            <div class="rateitem" :class="{rateitem_active:rateSelect == item}" v-for="item in dataAll"
             @click="selectrate(item)">{{item}}%</div>
             <div style="width: 100%;"><div class="rateitem" style="float:right;border: 2px solid #F53824;font-weight: 800;" @click="rateshow =!rateshow">关闭</div></div>
          </div>
        </div>
      </div>
      <div class="tablecon" ref="tablecon">
        <newgkmajorHeader showtype="tb" :guding="guding" :jhYear="jhYear"></newgkmajorHeader>
        <div class="three" id="yuanshu2">
          <newgkmajorInfo :ref="`${tianbaoType==2?item.dataid:item.id}`" :item="item" :checked="item.checked"
            :scoreyear="scoreYear" :index="index" :type="type" v-for="(item, index) in list" @select="selectItem"
            :key="index">
          </newgkmajorInfo>
          <loadData :loadding="loadding" :noMore="noMore" :total="total" :message="emptymsg"></loadData>
        </div>
      </div>
    </div>
    <tianbaoSubmit ref="tianbaoSubmit" @openyixuan="quityiyuan"></tianbaoSubmit>
    <item7></item7>
    <zyCollegeMajor v-if="isTrue" :obj="selectItemObj" :jhflag="true"
      :selectids="map.map[(tianbaoType==2?selectItemObj.dataid:selectItemObj.id)]" :type="type" datatype="type"
      @close="closezyCollegeMajor"></zyCollegeMajor>
    <zuoxuanfu1 ref="zuoxuanfu1" type="zy" @openyixuan="openyixuan"></zuoxuanfu1>
    <yixuaninfo @Tijiaog="openyixuan" v-if="isTijiao" @changetotype="changetotype" :scoreYear="scoreYear"></yixuaninfo>
    <toast :title="title" :message="message" @close="closetoast" v-if="toastflag" @quxiao="quxiao" :fun="fun"
      :flag="toastflag" :btn="que" :quxiaoName="quxiaoName"  :quitName="quitName"
       :obj="toastObj"
       @openyixuan="openyixuan"  :quxiaofun="openmajor">
    </toast>


  </div>
</template>
<script>
  import zuoxuanfu1 from '../../components/zuoxuanfu1.vue'
  import vHeader from "../../components/vHeader.vue";
  import vMassage from "../../components/vMassage.vue";
  import item7 from "../../components/item7.vue";
  import newgaokao750 from "../../../css/newgaokao750.css"
  import vCrumbs from '../../components/vCrumbs.vue'
  import tianbaotype from '../../components/tiabaoType.vue'
  import tianbaoSubmit from '../../components/tianbaoSubmit.vue'
  import newgkmajorHeader from '../../components/tianbaoHeader/newgkmajorHeader.vue'
  import newgkmajorInfo from '../../components/tianbaoInfo/newgkmajorInfo.vue'
  import yixuaninfo from '../../components/yixuaninfo.vue'
  import zyCollegeMajor from '../../components/zyCollegeMajor.vue'
  import vMassage1 from "../../components/vMassage1.vue";
  import toast from '../../components/toast.vue'
  import loadData from '../../components/loadData.vue'

  import CryptoJS from 'crypto-js'

  export default {
    props: [],
    components: {
      vHeader,
      vMassage,
      vCrumbs,
      item7,
      newgaokao750,
      zuoxuanfu1,
      tianbaotype,
      newgkmajorHeader,
      newgkmajorInfo,
      yixuaninfo,
      zyCollegeMajor,
      vMassage1,
      toast,
      tianbaoSubmit,
      loadData
    },
    data() {
      return {
        // 头固定
        guding: false,
        // 导航选中
        Name: 4,
        // 用来标识遮罩层显示与隐藏的
        isTijiao: false,
        isTrue: false,
        tianbaoModel: this.$utils.getlocalStorage('tianbaoModel'),
        pageSize: 10,
        pageNum: 1,
        total: 0,
        pages: 0,
        zytotal: 0,
        type: 'cyc',
        tianbaoType: this.$utils.getlocalStorage('tianbaoType'),
        queryObj: {
          userArea: this.$utils.getlocalStorage("scoreInfo").scoreArea,
          tianbaoGrade: "",
          up:this.batch,
          down:null,
          fenshu:[300,500]
        },
        marks: {
          180: '180',
          280: '280',
          400: '400',
          500: '500',
          600: '600',
          750: '750',
        },
        batch: this.$utils.getlocalStorage("userZhiYuanBatch"),
        areaInfo: this.$utils.getlocalStorage("areaInfo"),
        scoreInfo: this.$utils.getlocalStorage("scoreInfo"),
        userInfo: this.$utils.getlocalStorage('userInfo'),
        jhYear:2026,
        allData: {
          college_sun: 0,
          sun_byb: 0,
          sun_cyc: 0,
          sun_dyd: 0,
          sun_wyw: 0,
        },
        rateshow:false,
        dataAll:[],
        rateSelect:'',
        showcrumbs: true,
        md5str: "",
        queryKey: "",
        list: [],
        loadding: true,
        noMore: false,
        map: {}, //已选志愿
        selectItemObj: {},
        index: -1, //选中的志愿索引
        selectmajorlist: [],
        title: "",
        fun: 'quxiao',
        message: "",
        toastflag: false,
        que: 'que',
        tishi: 0,
        totype: "wyw",
        scoreYear: 2020,
        majorScoreYear: 2021,
        quxiaoName:"",
        quitName:"",
        quxiaofun:null,
        toastObj:null,
        downScore:null,
		tbcollegenum:0,
		//tishi:this.$utils.getlocalStorage("TISHI"),
		emptymsg:"",
		emptymsg1:"没有获取到合适的推荐志愿,请返回上一级选取合适的专业或省控线再次查询",
		emptymsg2:"未查询到任何数据,请修改筛选条件或专业再次查询"
      }
    },
    mounted() {
      console.log('zhuan_newgaokao')
      let zyadd = this.$utils.getlocalStorage('zyadd');
      if(zyadd!=null&&zyadd!=undefined&&zyadd!=''){
        if(this.tianbaoType!=0){
          this.$refs.tianbaotype.changedataAll(zyadd.type);
          this.$refs.tianbaoSubmit.changedataAll(zyadd.type);
          this.type = zyadd.type;
        }
        // this.rateSelect = zyadd.rate;
      }
      if (this.$utils.getLoginStatus()) {
        this.getAllData()
      }
      let showr = this.$utils.getlocalStorage("rateshow")


      if(showr == null){
        this.$utils.setlocalStorage("rateshow",1);
        if(this.tianbaoType!=0){
          this.rateshow = true;
        }
      }
      window.addEventListener('scroll', this.handleScrollx, true)
      this.$utils.setlocalStorage("selectZhiYuanType", this.type);
      this.map = this.$utils.getlocalStorage("ZhiYuan" + this.type)
      if (this.$utils.getlocalStorage("tianbaoModel") == 1) {
        this.selectmajorlist = this.$utils.getlocalStorage("zyyixuan").list
      }
    },
    methods: {
      searchMajor(obj) {
        this.queryObj.collegeAreas = obj.collegeAreas
        this.queryObj.collegeSubjection = obj.collegeSubjection
        this.queryObj.collegeSubject = obj.collegeSubject
        this.queryObj.collegeLevel = obj.collegeLevel
        this.queryObj.majorInfo = obj.majorInfo
        // this.queryObj.collegeNature = obj.collegeNature
        // this.searchName()
        this.pageNum = 1
        // this.total = 0
        this.rateSelect = ''
        this.rateshow = false;
        this.pages = 0
        this.list = []
        this.getData()
      },
      searchName() {
        if(this.queryObj.down!=null&&this.queryObj.down!=''){
		  if(this.downScore != parseInt(this.queryObj.down)){
			this.getAllData()
		  } else {
			this.searchName2();
		  }
		} else {
		  this.searchName2();
		}


      },
      searchName2(){
        this.pageNum = 1
        this.pages = 0
        this.list = []
        this.rateSelect = ''
        this.rateshow = false;
        window.scrollTo(0, 400);
        this.getData()
      },
      selectrate(rate) {
      	if (this.loading) {
      		return;
      	}
        window.scrollTo(0, 400);
      	this.rateSelect = rate;
      	this.pageNum = 1;
      	this.pages = 0;
      	this.list = [];
      	this.getData();
      },
      getAllData() {
        let _this = this;
        if (this.tianbaoType != 0) {
          let xuanke = _this.scoreInfo.scoreXuanke.split(",");
          let queryObj = {
            userArea: _this.scoreInfo.scoreArea,
            userScore: _this.scoreInfo.score,
            batch: this.batch.provincialBatch,
            tianbaoType: this.$utils.getlocalStorage('tianbaoType') + "",
            tianbaoGrade: "",
            //upScore: parseFloat(_this.scoreInfo.score) + parseInt(_this.queryObj.up),
            //downScore: parseFloat(_this.scoreInfo.score) -   parseInt(_this.queryObj.down),
            scoretype: _this.scoreInfo.scoreSubject,
            xk1: xuanke[0],
            xk2: xuanke[1],
            xk3: xuanke[2],
          }
          if(_this.queryObj.down !=null){
            queryObj.downScore = parseInt(_this.queryObj.down)
            this.downScore = parseInt(_this.queryObj.down)
          }
          if (this.$utils.getlocalStorage("tianbaoModel") == 1) {
            let ids = this.$utils.getlocalStorage("zyyixuan").ids;
            if (ids) {
              queryObj.majorids = ids.join(",");
            }
          }
          if(this.userInfo.userRole == 3||this.userInfo.userRole == 2){
            queryObj.userId = this.userInfo.userId
          }

          this.$req.queryAllVolunteer({
            pageSize: 0,
            pageNum: 0,
            queryObj: queryObj,
          }).then(function(response) {
            _this.allData = response.data
            _this.jhYear = response.data.majorJhYear
            _this.$utils.setlocalStorage("ZhiYuanSun", response.data)
			_this.tbcollegenum = response.data.college_sun;
            _this.queryKey = response.data.queryKey;
            _this.getData();
          })
        } else {
          _this.getData();
        }

      },
      getData() {
        let _this = this;
        if (this.pageNum == 1) {
          // window.scrollTo(0,70);
        }
        this.noMore = false;
        _this.queryObj.userScore = _this.scoreInfo.score;
        _this.queryObj.batch = this.batch.provincialBatch;
        _this.queryObj.scoretype = _this.scoreInfo.scoreSubject;
        _this.queryObj.userArea = _this.scoreInfo.scoreArea;
        _this.queryObj.rateSelect = this.rateSelect + ""

        if (this.tianbaoType != 0) {
          let xuanke = _this.scoreInfo.scoreXuanke.split(",");
          _this.queryObj.xk1 = xuanke[0];
          _this.queryObj.xk2 = xuanke[1];
          _this.queryObj.xk3 = xuanke[2];
          _this.queryObj.jhflag = true
          _this.queryObj.data_type = this.type;
          _this.queryObj.tianbaoType = this.tianbaoType + "";
          if(this.userInfo.userRole == 3||this.userInfo.userRole == 2){
            _this.queryObj.userId = this.userInfo.userId
          }
          if (this.$utils.getlocalStorage("tianbaoModel") == 1) {
            let ids = this.$utils.getlocalStorage("zyyixuan").ids;
            if (ids) {
              _this.queryObj.majorids = ids.join(",");
            }
          }
          //获取查询的key
          let keys = this.$utils.getqueryKey(_this.queryObj,this.userInfo.userRole,this.userInfo.userId)
          let emptyKey = CryptoJS.MD5(keys.keys).toString()
          //单次查询的 key
          let aloneKey = CryptoJS.MD5(keys.keyadd).toString()
          //如果没有查询条件 那就是查询全部 直接用空key查询

          this.loadding = true;
          this.$req.queryZyByTypeLimit({
            pageSize: _this.pageSize,
            pageNum: _this.pageNum,
            emptyKey: emptyKey,
            queryKey: this.queryKey,
            queryObj: _this.queryObj,
            aloneKey:aloneKey
          }).then(function(response) {
            _this.loadding = false;

            _this.list = _this.list.concat(response.data)
            _this.total = response.total;
			if(_this.tbcollegenum != 0){
				if(_this.total == 0){
					_this.emptymsg = _this.emptymsg2
				}
			} else {
				_this.emptymsg = _this.emptymsg1
			}
            _this.pages = response.pages;
            if(response.dataAll!=null){
              _this.dataAll = response.dataAll.rateList;
            }
            _this.queryKey = response.str;
            if (response.year) {
              _this.scoreYear = response.year
            }
          })
        } else {
          _this.queryObj.xiancha = (_this.scoreInfo.score - this.batch.provincialScore) + "";
          if (this.$utils.getlocalStorage("tianbaoModel") == 1) {
            let ids = this.$utils.getlocalStorage("zyyixuan").ids;
            if (ids) {
              _this.queryObj.majorids = ids.join(",");
            }
          }
          _this.queryObj.jhflag = true
          _this.queryObj.use_score = true;
          this.loadding = true;
          this.$req.collegeTianbao({
            pageSize: _this.pageSize,
            pageNum: _this.pageNum,
            queryObj: _this.queryObj,
            queryKey: _this.message
          }).then(function(response) {
            _this.loadding = false;
            _this.list = _this.list.concat(response.data)
            _this.total = response.total;
			if(_this.total == 0){
				_this.emptymsg = _this.emptymsg1

				if((_this.queryObj.collegeAreas!=null&&_this.queryObj.collegeAreas!='')||
				(_this.queryObj.collegeLevel!=null&&_this.queryObj.collegeLevel!='')||
				(_this.queryObj.collegeName!=null&&_this.queryObj.collegeName!='')||
				(_this.queryObj.collegeNature!=null&&_this.queryObj.collegeNature!='')||
				(_this.queryObj.collegeSubject!=null&&_this.queryObj.collegeSubject!='')||
				(_this.queryObj.collegeSubjection!=null&&_this.queryObj.collegeSubjection!='')||
				(_this.queryObj.majorInfo!=null&&_this.queryObj.majorInfo!='')||
				(_this.queryObj.majorName!=null&&_this.queryObj.majorName!='')
				){
					_this.emptymsg = _this.emptymsg2
				}



			}
            _this.pages = response.pages;
            _this.message = response.str
            if (response.year) {
              _this.scoreYear = response.year
            }
            console.log(12313)
            _this.$utils.setlocalStorage("ZhiYuanSun", response.dataAll)
            _this.$utils.getlocalStorage("TianbaoQueryKey", response.str);
          })
        }

      },
      quityiyuan(){
        let opencent = this.$utils.getTinbaoAlert(this.map.map, null, 1);
        if(opencent!=null&&opencent!=undefined){
          this.toastflag = true;
          this.title = opencent.title;
          //fun: 'quxiao',
          this.message = opencent.content;
          if(opencent.type == 1){
            this.que = 'qu'
          } else if(opencent.type == -1){
            this.que = 'que'
          } else if(opencent.type == 2){
            this.que ='que,qu'
          }
          this.totype = opencent.to;
          this.quxiaoName = opencent.quxiaoName;
          this.quitName = opencent.quitName;
          this.fun = opencent.fun
          this.toastObj = opencent.toastObj
        } else {
          this.toastflag = false;
        }
      },
      closetoast(){
        this.toastflag = false;
        if(this.tianbaoType!=0&&this.quxiaoName.indexOf("去")!=-1){
          if(this.totype != this.type){
            this.changetotype(this.totype)
          }
        } else if(this.tianbaoType!=1&&this.quxiaoName.indexOf("继续选择")!=-1){
           this.openmajor()
        }
      },
      openyixuan(obj) {
        let _this = this;
        this.toastflag = false;
        this.isTijiao = obj.flag
        var mo = function(e) {
          e.preventDefault();
        };
        if (!obj.flag) {
          this.$refs.tianbaoSubmit.changedataAll();
          this.map.ids.forEach(function(item) {
            if (_this.$refs[item]) {
              if (_this.$refs[item].length != 0) {
                _this.$refs[item][0].getData()
              }
            }
          })
          this.map = obj[this.type]
          document.body.style.overflow = '';
          //出现滚动条
          document.removeEventListener("touchmove", mo, false);
        } else {
          document.body.style.overflow = 'hidden';
          document.addEventListener("touchmove", mo, false);
        }
      },
      quxiao() {
        var mo = function(e) {
          e.preventDefault();
        };
        document.body.style.overflow = '';
        //出现滚动条
        document.removeEventListener("touchmove", mo, false);
        if (this.tishi == 1) {
          this.tishi = 0
          this.changetotype(this.totype)
        }
        this.toastflag = false;
      },
      changetotype(totype) {
        this.type = totype;
        this.changeType(totype)
        this.$refs.tianbaotype.changedataAll(totype);
        this.$refs.tianbaoSubmit.changedataAll(totype);
        this.isTijiao = false;
        var mo = function(e) {
          e.preventDefault();
        };
        document.body.style.overflow = '';
        //出现滚动条
        document.removeEventListener("touchmove", mo, false);
      },

      selectItem(index, flag, obj1) {
        this.map = this.$utils.getlocalStorage("ZhiYuan" + this.type)
        this.index = index;
        if (this.tianbaoType == 1) {
          let opencent = this.$utils.getTinbaoAlert(this.map.map, this.list[index], 0);
          if (opencent && flag) {
            this.title = opencent.title;
            this.fun = 'quxiao';
            this.message = opencent.content
            if (opencent.flag) {
              if (opencent.type == 2) {
                this.que = 'que,qu';
                this.totype = opencent.to
                this.toastflag = true;
                this.tishi = 1
              } else {
                this.que = 'que';
                this.toastflag = true;
              }
              return;
            }
          }

          let item = this.list[index];

          this.list[index].checked = flag
          this.$refs[obj1.id][0].changeflag(flag)

          let obj = item.obj;
          if (flag) {
            this.createMap(item);
          } else {
            let index = this.map.ids.indexOf(item.id);
            this.map.ids.splice(index, 1)
            delete this.map.map[item.id]
          }
          this.$utils.setlocalStorage("ZhiYuan" + this.type, this.map);
          this.$refs.zuoxuanfu1.zhiyuannum();
          this.$refs.tianbaoSubmit.changedataAll();
        } else {
          let opencent = this.$utils.getTinbaoAlert(this.map.map, this.list[index], 0);
          this.selectItemObj = this.list[index]
          if(opencent!=null&&opencent!=undefined){
            this.toastflag = true;
            this.title = opencent.title;
            //fun: 'quxiao',
            this.message = opencent.content;
            this.que = 'que,qu';
            this.quxiaoName = opencent.quxiaoName;
            this.quitName = opencent.quitName;
            this.fun = opencent.fun
            this.toastObj = opencent.toastObj
          } else {
            // que: 'que',
            this.openmajor()
          }
        }
      },
      openmajor(){
        this.toastflag = false;
        var mo = function(e) {
          e.preventDefault();
        };
        document.body.style.overflow = 'hidden';
        document.addEventListener("touchmove", mo, false);
        this.isTrue = true;
      },
      closezyCollegeMajor(obj) {
        var mo = function(e) {
          e.preventDefault();
        };
        document.body.style.overflow = '';
        //出现滚动条
        document.removeEventListener("touchmove", mo, false);
        let id = this.selectItemObj.id
        if (this.tianbaoType == 2) {
          id = this.selectItemObj.dataid
        }
        let n = this.map.ids.indexOf(id)
        if (obj.ids.length != 0) {
          if (n != -1) {
            this.map.map[id].ids = obj.ids;
            this.map.map[id].list = obj.yixuan;
          } else {
            this.createMap(this.selectItemObj, obj);
            this.list[this.index].checked = true
          }
        } else {
          if (n != -1) {
            this.map.ids.splice(n, 1)
            delete this.map.map[id]
            this.list[this.index].checked = false
          }
        }
        this.isTrue = false;
        this.$utils.setlocalStorage("ZhiYuan" + this.type, this.map);
        this.$refs.tianbaoSubmit.changedataAll();
        this.$refs[id][0].getData()
      },

      createMap(item, majorMap) {
        let id = item.id;
        if (this.tianbaoType == 2) {
          id = item.dataid;
        }
        let obj = item.obj
        let Select = {
          collegeId: obj.college_id,
          collegeName: obj.college_name,
          collegeSubject: obj.college_subject,
          collegeLevel: obj.college_level,
          collegeArea: obj.college_area,
          collegeNature: obj.college_nature,
          collegeType: obj.college_type,
          collegeCode: obj.college_code,
          collegeInfo: obj.college_info,
          collegeSubjection: obj.college_subjection,
          majorId: obj.major_id,
          majorCode: obj.major_code,
          majorName: obj.major_name,
          majorInfo: obj.major_info,
          studyMoney: obj.study_money,
          planflag: obj.planflag,
          groupname: obj.group_name,
          studyMoney: obj.tuition,
          tuition: obj.tuition,
          planYear: obj.plan_year,
          id: id,
          planNum: obj.plan_num,
          rate: item.rate,
          xuankeStr: this.$utils.getZyShowXuanKe(obj),
          show: true,
          type: this.type,
          score: item.list,
          college: item.college,
          major: item.major
        }
        if (this.tianbaoType != 1) {
          Select.ids = majorMap.ids;
          Select.list = majorMap.yixuan;

        }
        this.map.ids.push(id);
        this.map.map[id] = Select;
        console.log(this.map)
      },

      changeType(type) {

        this.type = type;
        console.log(type);
        window.scrollTo(0, 70);
        this.map = this.$utils.getlocalStorage("ZhiYuan" + this.type)
        this.$utils.setlocalStorage("selectZhiYuanType", this.type);
        this.pageNum = 1;
        // this.total = 0;
        this.pages = 0;
        this.rateSelect = ''
        this.list = []
        if (this.$utils.getlocalStorage("ZhiYuanSun")['sun_' + type] != 0) {
          this.getData();
        }
      },

      Tijiaog() {
        this.isTijiao = false;
      },


      handleScrollx() {
        if (this.$route.path == '/zhuan_newgaokao') {
          let tedItem = document.querySelector("#yuanshu1")
          let tedItem2 = document.querySelector("#yuanshu2")
          var scrollTop = tedItem.getBoundingClientRect().top
          var scrollTop2 = tedItem2.getBoundingClientRect().top
          if (scrollTop <= 0) {
            this.guding = true
          }
          if (scrollTop2 >= 119) {
            this.guding = false
          }

          const scrollY =
            document.body.scrollTop || document.documentElement.scrollTop; // 滚动条在Y轴上的滚动距离
          const compatibility =
            document.compatMode === "CSS1Compat" ?
            document.documentElement.clientHeight :
            document.body.clientHeight;
          // clientHeight 属性是一个只读属性，它返回该元素的像素高度，高度包含内边距（padding），不包含边框（border），外边距（margin）和滚动条，是一个整数，单位是像素 px。
          // 页面总高度
          const TotalHeight = Math.max(
            document.body.scrollHeight,
            document.documentElement.scrollHeight
          );
          // 当滚动条滑到页面底部
          if (compatibility + scrollY >= (TotalHeight - 600)) {

            if (this.pageNum < this.pages && !this.loadding) {
              this.pageNum++;
              this.getData()
            }
            if(this.pageNum >= this.pages){
              if (this.pages != 0 && !this.loadding) {
                this.noMore = true;
              }
            }
          }
        }

      },

      //===========================点击展开关闭效果====================================
      openShutManager(oSourceObj, oTargetObj, shutAble, oOpenTip, oShutTip) {
        var sourceObj = typeof oSourceObj == "string" ? document.getElementById(oSourceObj) : oSourceObj;
        var targetObj = typeof oTargetObj == "string" ? document.getElementById(oTargetObj) : oTargetObj;
        var openTip = oOpenTip || "";
        var shutTip = oShutTip || "";
        if (targetObj.style.display != "none") {
          if (shutAble) return;
          targetObj.style.display = "none";
          if (openTip && shutTip) {
            sourceObj.innerHTML = shutTip;
          }
        } else {
          targetObj.style.display = "block";
          if (openTip && shutTip) {
            sourceObj.innerHTML = openTip;
          }
        }
      },
    },
  };
</script>
<style scoped>
  .el-checkbox__inner {
    width: 20px !important;
    height: 20px !important;
  }

  .two_A {
    position: fixed;
    left: 50%;
    transform: translate(-51%);
  }

  .queryAll {
    width: 200px;
    font-size: 14px;
    font-weight: 800;
    height: 30px;
    margin-right: 10px;
    color: #F53824;
    line-height: 30px;
  }

  .ratelist {
    position: relative;
    left: -400px;
    top:20px;
    z-index: 100;
    height: 0px;
    width: 0px;
    background-color: #F53824;
  }
  .ratecontent{
    width: 400px;
    padding: 10px;
    border-radius: 15px;
    border: 1px solid #666666;
    height: auto;
    box-shadow: 0px -1px 5px rgba(0, 0, 0, 0.3);
    background-color: #FFFFFF;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    z-index: 10;

  }
  .rateitem{
    height: 24px;
    width: 50px;
    text-align: center;
    line-height: 24px;
    font-size: 13px;
    border-radius: 12px;
    margin: 2px;
    border: 1px solid #f66464;
    color: #f66464;
    /* font-weight: 800; */
  }
  .rateitem_active{
    color: #FFFFFF;
    background-color: #f66464;
  }

  .three_A {
    padding-top: 40px;
  }

  .dibudean {
    cursor: pointer;
    position: fixed;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 80px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px -1px 2px rgba(0, 0, 0, 0.05);
    opacity: 1;
  }

  .dibudean .ansdhu {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 160px;
    height: 46px;
    background: linear-gradient(131deg, #FE9603 0%, #F53824 100%);
    opacity: 1;
    border-radius: 5px;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }



  /* 改动中间 */
  .two_A div {
    color: #ffffff;
  }

  .ANAN::-webkit-scrollbar {
    width: 14px;
    height: 746px;
    background: rgba(246, 246, 246, 1);
    opacity: 1;
  }

  .ANAN::-webkit-scrollbar-thumb {
    width: 8px;
    height: 151px;
    background: rgba(245, 56, 36, 1);
    opacity: 1;
    border-radius: 4px;
  }

  .Cont9_B p {
    color: #ffffff;
  }

  .gudingop {
    position: fixed;
    top: 135px;
    left: ;
    -webkit-transform: translate(0);
    transform: translate(0);
    margin-top: 0 !important;
    width: 1280px !important;
    z-index: 2;
  }

  /* 改动中间 */
  .query {
    /* width: 100%; */
    /* height: 60px;
    background: rgba(248, 248, 248, 1);
    border-radius: 5px;
    align-items: center;
    margin-top: 0px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center; */
    margin-top: 10px;
    justify-content: left;
    width: 100%;
    height: 45px;
    background: #FFFFFF;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.16);
    border-radius: 5px;
    display: flex;
    justify-content: start;
    align-items: center;
    padding-left: 20px;
  }

  .query .query_top {
    display: flex;
    margin-left: 20px;
  }

  .query_top p {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    display: flex;
    align-items: center;
  }

  .query_top input {
    width: 140px;
    height: 30px;
    background: rgba(255, 255, 255, 0.39);
    border: 1px solid #E0E0E0;
    opacity: 1;
    border-radius: 5px;
    padding-left: 10px;
    box-sizing: border-box;
  }

  ::-webkit-input-placeholder {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #999999;
  }

  .query_bot {
    width: 100px;
    height: 30px;
    margin-left: 20px;
    background: linear-gradient(180deg, #29A7E1 0%, #3EC2FF 100%);
    opacity: 1;
    border-radius: 4px;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    cursor: pointer;
  }

  .query_bot img {
    width: 14px;
    height: 14px;
  }

  .query_bot p {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }

  .centea {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }



  /* 中间内容 */
  .three {
    width: 100%;
    height: auto;
    margin-top: 11px;
    margin-bottom: 55px;
    min-height: 550px;
  }



  /* 遮罩层 查看专业遮罩层 ↓ */
  .mask {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 120;
    background-color: rgba(0, 0, 0, 0.7);
  }

  .maskA {
    width: 910px;
    height: 90vh;
    background: rgb(255, 255, 255);
    border-radius: 20px;
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    overflow: hidden;
  }

  .maskAA {
    width: 910px;
    height: 64px;
    background-image: url("../../../src/assets/img/zzctop.png");
    background-size: 100% 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 28px;
    padding-left: 28px;
    box-sizing: border-box;
    margin-bottom: 10px;
  }

  .maskAA img {
    width: 28px;
    height: 28px;
    cursor: pointer;
  }

  .ANAN {
    width: 100%;
    height: calc(100% - 64px);
    overflow-y: scroll;
    padding-bottom: 40px;
  }

  .maskAA p {
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #ffffff;
  }


  /* 遮罩层 填报志愿遮罩层 ↓ */
  .maskB {
    width: 512px;
    height: 285px;
    background: rgba(255, 255, 255, 1);
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    overflow: hidden;
  }

  .maskBAB {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .maskBAB p {
    margin-top: 20px;
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #29A7E1;
  }

  .maskBAB img {
    width: 24px;
    height: 24px;
    position: absolute;
    top: 30px;
    right: 30px;
    cursor: pointer;
  }

  .maskBbot {
    width: 100%;
    display: flex;
    justify-content: space-evenly;
    flex-wrap: wrap;
    column-count: 4;
    padding: 30px;
    margin: auto;
  }

  .maskBbot .maskBtt {
    width: 98px;
    height: 44px;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    text-align: center;
    line-height: 44px;
    margin-top: 20px;
    border: 2px solid #999999;
    border-radius: 10px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #999999;
    cursor: pointer;
  }

  .maskBtt img {
    width: 18px;
    height: 18px;
  }

  .maskBtt1 {
    width: 98px;
    height: 44px;
    display: flex;
    justify-content: space-evenly;
    background-image: url(../../../src/assets/img/zshtbzytc.png);
    background-size: 100% 100%;
    color: white !important;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    text-align: center;
    margin-top: 20px;
    line-height: 44px;
  }

  .maskBtt1 img {
    display: none;
  }

  /* 未关注 */
  .weiguanzhuA {
    margin-left: 20px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    width: 62px;
    height: 24px;
    background-image: url(../../../src/assets/img/weiguanzhu.png);
    background-size: 100% 100%;
  }

  .weiguanzhuA img {
    width: 13px;
    height: 14px;
  }

  .weiguanzhuA p {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
  }

  /* 未关注 */
  /* 已关注 */
  .weiguanzhuB {
    margin-left: 20px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    width: 62px;
    height: 24px;
    background-image: url(../../../src/assets/img/yiguanzhu.png);
    background-size: 100% 100%;
  }

  .weiguanzhuB img {
    display: none;
  }

  .weiguanzhuB p {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }

  /* 已关注 */
  .Cont_Nr_A_A {
    display: flex;
    align-items: center;
    margin: 10px 0;
  }

  /* 未选择专业  */
  .Cont9_AAA1 {
    display: flex;
    justify-content: center;
    width: 92px;
    height: 36px;
    background-image: url("../../../src/assets/img/wxzhuanye.png");
    background-size: 92px 36px;
    align-items: center;
    cursor: pointer;
  }

  .Cont9_AAA1 p {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #F53824;
  }

  /* 未选择专业  */
  /* 点击选择专业  */
  .Cont9_BBB1 {
    display: flex;
    justify-content: center;
    width: 92px;
    height: 36px;
    background-image: url("../../../src/assets/img/yxzhuanye.png");
    background-size: 92px 36px;
    align-items: center;
    cursor: pointer;
  }

  .Cont9_BBB1 p {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }

  /* 点击选择专业  */
  .bottijiao {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 64px;
    background: rgb(255, 255, 255);
    box-shadow: 0px -1px 10px rgba(0, 0, 0, 0.1);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .bottijiao p {
    background: linear-gradient(131deg, #FE9603 0%, #F53824 100%);
    border-radius: 5px;
    padding: 7px 18px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    cursor: pointer;
  }

  .mask_nr {
    padding: 20px;
    box-sizing: border-box;
  }

  /* 我写的！！！！！！！ */
  .mask_nr {
    width: 100%;
    height: calc(100% - 64px);
    padding: 20px;
    box-sizing: border-box;
    overflow: auto;
  }

  .ANAN1 {
    width: 100%;
    height: calc(100% - 64px);
  }

  @media (max-width:750px) {
    .gudingo {
      width: 100% !important;
      overflow-y: hidden;
      overflow-x: auto;
    }

    .gudingo .T_title8 {
      width: 300px !important;
      flex-shrink: 0;
      flex: none;
    }

    .gudingo .T_title0 {
      width: 104px;
    }

    .gudingo .T_title1 {
      width: 269px;
    }

    .gudingo .T_title2 {
      width: 78.8px;
    }

    .gudingo .T_title3 {
      width: 78.8px;
    }

    .gudingo .T_title4 {
      width: 119.8px;
    }

    .gudingo .T_title5 {
      width: 89.8px;
    }

    .gudingo .T_title6 {
      width: 119.8px;
    }

    .gudingo .T_title7 {
      width: 119.8px;
    }

    .gudingo .T_title8 {
      width: 404.8px !important;
    }

    .gudingo .T_title9 {
      width: 119.8px;
    }

    .gudingo {
      justify-content: normal !important;
    }

    .gudingo div {
      flex-shrink: 0;
    }

    .two_A {
      overflow-y: hidden;
      overflow-x: auto;
      width: 100% !important;
      margin-left: 20px;
    }

    .T_title1_A {
      width: 322.9px;
      flex-shrink: 0;
    }

    .T_title8_A {
      width: 390.99px;
      flex-shrink: 0;
    }

    .T_title9_A {
      width: 135.99px;
      flex-shrink: 0;
    }






    .query {
      flex-direction: column;
      margin-top: 40px;
      margin-bottom: 55px;
    }

    .query_top {
      margin-top: 10px;
    }

    .query_top input {
      width: 220px;
    }

    .query_bot {
      margin-top: 10px;
      line-height: 37px;
    }

    .two {
      width: 1500px;
    }

    .tablecon {
      overflow: auto;

    }

    .three {
      width: 1500px;
    }

    .maskB {
      width: 80%;
      height: auto;
    }

    .maskA {
      width: 80%;
      height: 80%;
    }

    .maskAA {
      width: 100%;
    }

    .maskAA p {
      font-size: 16px;
    }

    .ANAN {
      padding: 0 15px;
    }

    .three_A {
      width: 850px;
    }
  }

  @media (max-width:980px) {
    .query {
      margin-top: 40px;
      margin-bottom: 55px;
    }

    .query_top {
      margin-top: 10px;
    }

    .query_top input {
      width: 220px;
    }

    .query_bot {
      margin-top: 10px;
      line-height: 37px;
    }

    .two {
      width: 1500px;
    }

    .tablecon {
      overflow: auto;
    }

    .three {
      width: 1500px;
    }

    .maskB {
      width: 80%;
      height: auto;
    }

    .maskA {
      width: 80%;
      height: 80%;
    }

    .maskAA {
      width: 100%;
    }

    .maskAA p {
      font-size: 16px;
    }

    .ANAN {
      padding: 0 15px;
    }

    .three_A {
      width: 850px;
    }

    /* 我写的 */
    .maskA {
      width: 80%;
      height: 80%;
    }

    .maskAA {
      width: 100%;
    }

    .shipei {
      display: none;
    }

    .clomxia {
      /* flex-direction: column; */
    }

    .mask_nr {
      width: 100%;
      height: calc(100% - 64px);
    }

  }

  /* @media (max-width:1400px) {
    .query {
      margin-top: 0px;
      margin-bottom: 15px;
      height: auto;
      padding: 15px 0;
    }

    .query_top {
      margin-top: 10px;
    }

    .query_top input {
      width: 220px;
    }

    .query_bot {
      margin-top: 10px;
      line-height: 37px;
    }


    .tablecon {
      overflow: auto;
    }

    .three {
      width: 1500px;
    }

    .maskB {
      width: 80%;
      height: auto;
    }

    .maskA {
      width: 80%;
      height: 80%;
    }

    .maskAA {
      width: 100%;
    }

    .maskAA p {
      font-size: 16px;
    }

    .ANAN {
      padding: 0 15px;
    }

    .three_A {
      width: 850px;
    }

    .maskA {
      width: 90%;
      height: 85%;
    }

    .generateList li {
      width: 930px;
    }

    .maskAA {
      width: 100%;
    }

    .mask_nr {
      width: 100%;
      height: calc(100% - 64px);
    }
  } */
</style>



// WEBPACK FOOTER //
// src/views/tianbaoList/zhuan_newgaokao.vue